import { Entry } from '../Entry'

export function Entry20250410() {
  return (
    <Entry title="2025 Apr 10 - v3.10.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17766/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
